import { useEffect, useState } from "react";

function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        console.log("Debouncing...");
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => { clearTimeout(handler); };
    }, [value, delay]);

    return debouncedValue;
}

export default useDebounce;